import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { articles } from "@/mocks/articleData";

export default function ArticlesSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 border border-foreground-200 text-foreground-500 text-xs font-medium rounded-lg tracking-wider uppercase">
            BLOG SEO
          </span>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 mt-5 leading-tight">
            Guias e Artigos{" "}
            <span className="text-foreground-300">Hoobuy Sheet</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-4 max-w-lg mx-auto">
            Conteúdo original e otimizado para Google sobre compras na China, segurança, tendências e poupança.
          </p>
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/artigo/${article.slug}`}
              className="flex flex-col rounded-2xl border border-background-200/70 bg-background-50 hover:bg-accent-50 hover:border-accent-200 transition-all duration-300 cursor-pointer group overflow-hidden"
            >
              {/* Image */}
              <div className="w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>

              {/* Content */}
              <div className="flex flex-col gap-2 p-4 md:p-5 flex-1">
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-accent-700 transition-colors leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mt-1">
                  {article.description}
                </p>
                <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors mt-auto pt-2">
                  {t("articles.readMore")}
                  <i className="ri-arrow-right-line text-sm group-hover:translate-x-0.5 transition-transform"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        {/* All Articles CTA */}
        <div className="text-center mt-12">
          <Link
            to="/artigo/guia-completo-hoobuyspreadsheet"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 border border-foreground-300 text-foreground-800 text-sm font-medium rounded-full hover:bg-background-50 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            {t("articles.viewAll")}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}